import {
  HomeIcon,
  SparklesIcon,
  PlusIcon,
  CalendarIcon,
  ChartBarIcon,
  BanknotesIcon,
  QuestionMarkCircleIcon,
  UsersIcon,
  BriefcaseIcon,
  ClipboardDocumentListIcon,
} from "@heroicons/react/24/outline";

export const reviewsConstants = [
  {
    name: "Jane Doe",
    time: "2 days ago",
    rating: 5,
    text: "An absolutely breathtaking experience. Highly recommended!",
    experience: "Mountain Hiking Tour",
    avatar: "https://i.pravatar.cc/150?img=1",
  },
  {
    name: "John Smith",
    time: "4 days ago",
    rating: 5,
    text: "The food tour was delicious. Great way to explore the city.",
    experience: "City Culinary Walk",
    avatar: "https://i.pravatar.cc/150?img=2",
  },
  {
    name: "Emily White",
    time: "1 week ago",
    rating: 5,
    text: "Paddling along the coast felt so serene. We felt very safe.",
    experience: "Coastal Kayaking",
    avatar: "https://i.pravatar.cc/150?img=3",
  },
  {
    name: "Chris Murray",
    time: "5 days ago",
    rating: 4,
    text: "Really fun experience, but the weather was too hot.",
    experience: "Desert Safari",
    avatar: "https://i.pravatar.cc/150?img=4",
  },
];

export const baseURLQA =
  "https://toucan-backend-dev-edfuazcsahapdchy.canadacentral-01.azurewebsites.net/api/v1";
export const baseURLRelease =
  "https://toucan-backend-dev-edfuazcsahapdchy.canadacentral-01.azurewebsites.net/api/v1";
export const baseURLMain =
  "https://toucan-backend-dev-edfuazcsahapdchy.canadacentral-01.azurewebsites.net/api/v1";
export const baseURLProd =
  "https://toucan-backend-f0cse6ftbkesbggs.canadacentral-01.azurewebsites.net/api/v1";

export const vendorNavigation = [
  { name: "Dashboard Overview", href: "/vendor/dashboard", icon: HomeIcon },
  { name: "My Experiences", href: "/vendor/experiences", icon: SparklesIcon },
  {
    name: "Add New Experience",
    href: "/vendor/experiences/new",
    icon: PlusIcon,
  },
  { name: "Bookings", href: "/vendor/bookings", icon: CalendarIcon },
  { name: "Analytics", href: "/vendor/analytics", icon: ChartBarIcon },
  { name: "Payouts", href: "/vendor/payouts", icon: BanknotesIcon },
  { name: "Support", href: "/vendor/support", icon: QuestionMarkCircleIcon },
];

export const adminNavigation = [
  { name: "Dashboard Overview", href: "/admin/dashboard", icon: HomeIcon },
  {
    name: "Vendor Management",
    href: "/admin/vendor-management",
    icon: BriefcaseIcon,
  },
  {
    name: "Experience Management",
    href: "/admin/experience-management",
    icon: SparklesIcon,
  },
  {
    name: "User Management",
    href: "/admin/user-management",
    icon: UsersIcon,
  },
  {
    name: "Booking Management",
    href: "/admin/booking-management",
    icon: CalendarIcon,
  },
  {
    name: "Support Ticket",
    href: "/admin/support-ticket",
    icon: ClipboardDocumentListIcon,
  },
  {
    name: "Payouts",
    href: "/admin/payment-management",
    icon: BanknotesIcon,
  },
];

export const SHOW_BUTTON_STATUSES = [
  "upcoming",
  "ongoing",
  "vendor proposed alternate time",
  "awaiting user confirmation",
];

export const MONTH_MAP = {
  0: "January",
  1: "February",
  2: "March",
  3: "April",
  4: "May",
  5: "June",
  6: "July",
  7: "August",
  8: "September",
  9: "October",
  10: "November",
  11: "December",
};
